import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { GuardEither } from './GuardEither.js';
import { GuardRemote } from './GuardRemote.js';
/**
 * Guard a render tree from rendering unless we have a right value
 */
export const GuardRemoteEither = ({ render, alt, ...remoteProps }) => (_jsx(GuardRemote, { ...remoteProps, render: (value) => _jsx(GuardEither, { value, render, alt }) }));
//# sourceMappingURL=GuardRemoteEither.js.map